// extracted by mini-css-extract-plugin
export var labelWrapper = "_gp-0";